import { getPath } from 'utils/navigation/navigate';
import { Configs } from 'constants/app/configs';

export const navigateToExplore = () => {
  window.location.href = getPath(Configs.PAGE_URLS.EXPLORE);
};
